import "./index.css";
//import myImage from "../../images/profile-white-bg.jpg";


function SocialMedia(){

	return(
		<section id='social-media'>
			<h2 className='rock'> My Social Media </h2>

			<div className='social'>

				<article className='profile' data-aos="flip-left" data-aos-duration="1200">
					<div className='bluewall'> </div>					
					
					<div className='account'>
						<img src="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp" 
							alt="social-media icon of Ibrahim B. Oduola" loading="lazy" 
							srcSet="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg-480p.webp 480w, https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp" 
							sizes="(max-width: 1080px) 120px, 1020px"
							/>
						<a href="https://www.twitter.com/theibrahim_o/" className='enchanted' target='_blank' rel="noreferrer"> Twitter </a>
					</div>

				</article>

				<article className='profile' data-aos="flip-left" data-aos-duration="1200">
					<div className='bluewall'> </div>					
					
					<div className='account'>
						<img src="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp" 
							alt="social-media icon of Ibrahim B. Oduola" loading="lazy" 
							srcSet="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg-480p.webp 480w, https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp" 
							sizes="(max-width: 1080px) 120px, 1020px"
							/>
						<a href="https://www.linkedin.com/in/ibrahim-oduola/" className='enchanted' target='_blank' rel="noreferrer"> LinkedIn </a>
					</div>

				</article>

				<article className='profile' data-aos="flip-left" data-aos-duration="1200">
					<div className='bluewall'> </div>					
					
					<div className='account'>
						<img src="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp"
							alt="social-media icon of Ibrahim B. Oduola" loading="lazy" 
							srcSet="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg-480p.webp 480w, https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp" 
							sizes="(max-width: 1080px) 120px, 1020px"
							/>
						<a href="https://www.github.com/theibrahim7" className='enchanted' target='_blank' rel="noreferrer"> Github </a>
					</div>

				</article>

				<article className='profile' data-aos="flip-left" data-aos-duration="1200">
					<div className='bluewall'> </div>					
					
					<div className='account'>
						<img src="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp" 
						alt="social-media icon of Ibrahim B. Oduola" loading="lazy" 
						srcSet="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg-480p.webp 480w, https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/profile-white-bg.webp" 
						sizes="(max-width: 1080px) 120px, 1020px"
						/>
						<a href="https://www.stackoverflow.com/users/10984641/ibrahim" className='enchanted' target='_blank' rel="noreferrer"> Stack Overflow </a>
					</div>

				</article>

			</div>


		</section>
		)
};

export default SocialMedia;